__turbopack_context__.v({
  "controls": "StartpageHero-module-scss-module__aM6eyG__controls",
  "description": "StartpageHero-module-scss-module__aM6eyG__description",
  "fade-in": "StartpageHero-module-scss-module__aM6eyG__fade-in",
  "header": "StartpageHero-module-scss-module__aM6eyG__header",
  "heading": "StartpageHero-module-scss-module__aM6eyG__heading",
  "highlight": "StartpageHero-module-scss-module__aM6eyG__highlight",
  "highlights": "StartpageHero-module-scss-module__aM6eyG__highlights",
  "links": "StartpageHero-module-scss-module__aM6eyG__links",
  "no-transform": "StartpageHero-module-scss-module__aM6eyG__no-transform",
  "rotate": "StartpageHero-module-scss-module__aM6eyG__rotate",
  "searchBarButton": "StartpageHero-module-scss-module__aM6eyG__searchBarButton",
  "wrapper": "StartpageHero-module-scss-module__aM6eyG__wrapper",
});
